var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPieChart2Fill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.7189 2.11218C6.33084 2.51169 2.0835 7.00983 2.0835 12.5C2.0835 17.9901 6.33084 22.4883 11.7189 22.8878V15.5265C10.3711 15.1796 9.37516 13.9561 9.37516 12.5C9.37516 11.0439 10.3711 9.82035 11.7189 9.47342V2.11218Z",
    fill: "#CD6EE5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8878 13.2812C22.5074 18.4114 18.4114 22.5074 13.2812 22.8878V15.5266C14.3794 15.2439 15.2439 14.3794 15.5266 13.2812H22.8878Z",
    fill: "#CD6EE5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8878 11.7187H15.5266C15.2439 10.6206 14.3794 9.75608 13.2812 9.47342V2.11218C18.4114 2.49256 22.5074 6.58858 22.8878 11.7187Z",
    fill: "#CD6EE5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPieChart2Fill);
export default __webpack_public_path__ + "static/media/pie_chart_2_fill.4d530e34719caaf13dfee06275000750.svg";
export { ForwardRef as ReactComponent };